import { useEffect, useRef } from "react";
import { ChatMessage, ConversationState } from "@/components/agent/chat/types";

// Time in milliseconds before a conversation is auto-closed (handled by edge function)
const AUTO_CLOSE_TIMEOUT = 10 * 60 * 1000; // 10 minutes

interface UseConversationAutoCloseProps {
  messages?: ChatMessage[] | null;
  conversationId: string | null;
  conversationState?: ConversationState;
  setConversationState?: (state: ConversationState) => void;
}

export const useConversationAutoClose = ({
  messages = [],
  conversationId = null,
  conversationState = "open",
  setConversationState = () => {},
}: UseConversationAutoCloseProps) => {
  const processingRef = useRef(false);

  useEffect(() => {
    // This hook is now simplified to only handle client-side inactivity detection if needed
    // The actual auto-closing of inactive conversations is handled by the 
    // 'auto-close-conversations' edge function on the server side
    
    // Early return if conversation is already completed
    if (conversationState === "completed" || !conversationId) {
      return;
    }

    // All automatic closing based on AI patterns has been removed
    // Users must now manually click the "Submit & Close" button
    // Only server-side inactivity auto-close remains active (10 minutes)
    
  }, [conversationId, conversationState]);
};
